import { render, staticRenderFns } from "./InviteReward.vue?vue&type=template&id=5727a59b&scoped=true"
import script from "./InviteReward.vue?vue&type=script&lang=js"
export * from "./InviteReward.vue?vue&type=script&lang=js"
import style0 from "./InviteReward.vue?vue&type=style&index=0&id=5727a59b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5727a59b",
  null
  
)

export default component.exports